(function() {
  let vScroller = document.querySelector('.vertical-scroller .strip');
  if (vScroller.length == 0) return;
  let currencyCards = vScroller.querySelectorAll('.item');
  let ANIMATION_SPEED = 1400;
  let countryName = document.getElementsByClassName('country-name')[0];
  let heightDesktop = currencyCards[0].offsetHeight,
    marginDesktop = parseInt(
      window.getComputedStyle(currencyCards[0]).marginBottom,
      10
    ),
    widthMobile = currencyCards[0].offsetWidth,
    marginMob = parseInt(
      window.getComputedStyle(currencyCards[0]).marginRight,
      10
    ),
    oldRandomVisibleIndex = -1;
  const NO_OF_CARDS_IN_A_ROW = 2,
    NO_OF_ITEMS_VISIBLE_ON_SCREEN = 2 * NO_OF_CARDS_IN_A_ROW;
  let el = currencyCards[1]; // 2nd item by default active
  let prevEl = el;
  setInterval(function() {
    prevEl.classList.remove('active');
    if (window.innerWidth < 1024)
      // mobile
      el = getRandomVisibleCardMob();
    else el = getRandomVisibleCard();
    el.classList.add('active');
    countryName.innerText = el.getAttribute('data-country');
    prevEl = el;
  }, ANIMATION_SPEED);

  // updates width/height and margin values when device rotated
  function setCurrentValues() {
    heightDesktop = currencyCards[0].offsetHeight;
    marginDesktop = parseInt(
      window.getComputedStyle(currencyCards[0]).marginBottom,
      10
    );
    widthMobile = currencyCards[0].offsetWidth;
    marginMob = parseInt(
      window.getComputedStyle(currencyCards[0]).marginRight,
      10
    );
  }

  window.addEventListener('resize', setCurrentValues);

  /**
   * Get visible currency card in banner to add highlight to it by increasing its size and then add correspoding currency name in banner
   */
  function getRandomVisibleCard() {
    let yAxisPos = window
      .getComputedStyle(vScroller)
      .getPropertyValue('transform')
      .match(/(-?[0-9\.]+)/g)[5];
    let visibleRowStartsFrom =
      parseInt(Math.abs(yAxisPos) / (heightDesktop + marginDesktop)) + 1;
    let startIndexOfVisibleCard =
      (visibleRowStartsFrom - 1) * NO_OF_CARDS_IN_A_ROW + 2;
    let randomVisibleIndex =
      Math.floor(
        Math.random() *
          (startIndexOfVisibleCard +
            NO_OF_ITEMS_VISIBLE_ON_SCREEN -
            1 -
            startIndexOfVisibleCard +
            1)
      ) + startIndexOfVisibleCard;
    while (randomVisibleIndex == oldRandomVisibleIndex) {
      randomVisibleIndex =
        Math.floor(
          Math.random() *
            (startIndexOfVisibleCard +
              NO_OF_ITEMS_VISIBLE_ON_SCREEN -
              1 -
              startIndexOfVisibleCard +
              1)
        ) + startIndexOfVisibleCard;
    }
    oldRandomVisibleIndex = randomVisibleIndex;
    return currencyCards[randomVisibleIndex];
  }

  function getRandomVisibleCardMob() {
    let transformValue = window
      .getComputedStyle(vScroller)
      .getPropertyValue('transform')
      .match(/(-?[0-9\.]+)/g)[4];
    let startIndexOfVisibleCard =
      parseInt(Math.abs(transformValue) / (widthMobile + marginMob)) + 2;
    return currencyCards[startIndexOfVisibleCard];
  }
})();
